var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindmoreSimpleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1394 31.2084C28.1204 31.2084 31.3477 27.9814 31.3477 24.0006C31.3477 20.0198 28.1204 16.7927 24.1394 16.7927C20.1584 16.7927 16.9312 20.0198 16.9312 24.0006C16.9312 27.9814 20.1584 31.2084 24.1394 31.2084Z",
    fill: "#062447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82781 24.0005H0C0.00706514 17.6374 2.53802 11.537 7.0376 7.03761C11.5372 2.5382 17.6379 0.0072373 24.0013 0V7.83024C19.7135 7.83429 15.6024 9.53917 12.5702 12.5707C9.53803 15.6023 7.83247 19.7129 7.82781 24.0005Z",
    fill: "#062447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.998 40.1704V48C30.3614 47.9928 36.4621 45.4621 40.9617 40.9629C45.4614 36.4637 47.9926 30.3635 48 24.0005H40.166C40.1613 28.2871 38.4564 32.3967 35.4255 35.4281C32.3945 38.4594 28.2849 40.1649 23.998 40.1704Z",
    fill: "#126CD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9981 48V40.1704C19.7109 40.1654 15.6007 38.4602 12.5693 35.4288C9.53781 32.3974 7.83263 28.2874 7.82781 24.0005H0C0.00740784 30.3628 2.53806 36.4624 7.03688 40.9615C11.5357 45.4606 17.6354 47.9918 23.9981 48Z",
    fill: "#126CD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindmoreSimpleIcon);
export default __webpack_public_path__ + "static/media/findmore_simple_icon.a2850676fb5c07f0a2d910b0724841b2.svg";
export { ForwardRef as ReactComponent };